import React, { useState } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Bluebutton from "../../components/blueButton/Bluebutton";
import Testimonial1 from "../../components/testimonial1/Testimonial1";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Container, Row, Col } from "react-bootstrap";
import Arrow from "./Arrow3.png";
import Img1 from "./img1.png";
import Briefcase from "./ph_briefcase.png";
import Exchange from "./uil_exchange.png";
import OcticonGraph from "./octicon_graph-24.png";
import Icomoon from "./icomoon-free_cogs.png";
import Lightbulb from "./flowbite_lightbulb-outline.png";
import Trophy from "./iconoir_trophy.png";
import Shield from "./Shield.png";
import bgImage from "./bg1.png";
import Rectangle from "./Rectangle.png";
import ArrowTop from "./ArrowTop.png";
import Servicesvg1 from "./servicesvg1.png";
import Servicesvg2 from "./servicesvg2.png";
import Servicesvg3 from "./servicesvg3.png";
import Servicesvg4 from "./servicesvg4.png";
import "./services.css";
import {  FaBriefcase ,FaLaptopCode , FaStethoscope ,FaClipboard } from "react-icons/fa";

const Services4 = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const services = [
    {
      title: "Market Research",
      description:
        "Conducting detailed market research to understand your target audience and their needs.",
      icon: Servicesvg1,
      mainicon: <FaBriefcase className="servicesIcon" />,
    },
    {
      title: "Customer Satisfaction Surveys",
      description:
        "Helping you gauge customer satisfaction and improve your offerings based on their feedback.",
      icon: Servicesvg2,
      mainicon: <FaLaptopCode className="servicesIcon" />,
    },
    {
      title: "Employee Engagement Surveys",
      description:
        "Providing insights into employee engagement to foster a positive and productive work environment.",
      icon: Servicesvg3,
      mainicon: <FaStethoscope className="servicesIcon" />,
    },
    {
      title: "Brand Perception Surveys",
      description:
        "Assessing how your brand is perceived by the public and identifying opportunities for growth.",
      icon: Servicesvg4,
      mainicon: <FaClipboard className="servicesIcon" />,
    },
  ];
  return (
    <>
      <Navb />
      <Container
        className="aboutHeader row p-0 align-items-center justify-content-center"
        style={{ margin: "2rem auto" }}
      >
        <div className=" aboutHeaderText1 col-lg-6 col-md-10 col-sm-12 text-center text-lg-start">
          <div className="d-flex justify-content-center justify-content-lg-start gap-3 pb-2">
            <span
              style={{ "font-weight": "600", color: "var(--primary-color)" }}
            >
              Our Services
            </span>
          </div>
          <div
            className="Heading43 mt-2 mt-lg-0 mb-4"
            style={{ "line-height": "55px", color: "var(--primary-color)" }}
          >
           Survey Services
          </div>
          <div className="ms-1 ms-lg-5 pb-3">
            <div className="fw-bold" style={{ color: "var(--primary-color)" }}>
            Comprehensive Market Insights
            </div>
            <div>
            Udaya Solutions offers survey services that provide accurate insights into consumer behavior and market trends, helping you make informed decisions.
            </div>
          </div>
          <div className="ms-1 ms-lg-5">
            <div className="fw-bold" style={{ color: "var(--primary-color)" }}>
            Targeted & Reliable Data Collection
            </div>
            <div>
            We ensure reliable, genuine responses through a rigorous screening process, offering actionable data to guide your business strategy.
            </div>
            <div className="mt-3 mb-3 mb-lg-1 d-flex justify-content-center justify-content-lg-start">
              <Bluebutton Text="Get in Touch" Link="contact" />
            </div>
          </div>
        </div>
        <div
          className="aboutimgHeader col-lg-6 col-md-10  px-4"
          style={{ overflow: "hidden", borderRadius: "18px" }}
        >
          <img src={Img1} alt="Img1" style={{ width: "100%" }} />
        </div>
      </Container>

      <Container className="py-4">
        <div className="row justify-content-center">
          <div ccol-md-10>
            <div
              className="text-white"
              style={{
                backgroundImage: `url(${bgImage})`,
                borderRadius: "60px",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <div className="p-5">
                <h2 className="text-center mb-4">
                  Find your career in few simple steps.
                </h2>
               
                <p>
                Our vast network and unique engagement strategies enable us to penetrate different industry sectors and demographics seamlessly. This has positioned us as the go-to agency for brands seeking a holistic view of their market environment. Furthermore, our rigorous screening processes ensure that every respondent we enlist is genuine and informed and provides actionable insights. At Udaya Solutions, our survey team is meticulously orchestrated to offer a gateway into the minds of consumers and the pulse of market sector. We provide a 360-degree view of your market landscape, thus enabling you to make well-informed, data-driven decisions.
                </p>
                
                
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* <Container className="row serviceMidBackImg1 justify-content-center">
        <div className="col-md-10 col-sm-11">
          <div className="serviceMidText1">
          Our vast network and unique engagement strategies enable us to penetrate different industry sectors and demographics seamlessly. This has positioned us as the go-to agency for brands seeking a holistic view of their market environment. Furthermore, our rigorous screening processes ensure that every respondent we enlist is genuine and informed and provides actionable insights. At Udaya Solutions, our survey team is meticulously orchestrated to offer a gateway into the minds of consumers and the pulse of market sector. We provide a 360-degree view of your market landscape, thus enabling you to make well-informed, data-driven decisions.
          </div>
        </div>
      </Container> */}
      <Container className="newSection">
        <p className="mt-5 text-center">
          Udaya Solutions recruiters are Senior Recruiters with at least 10
          years of recruitment experience. With an national/international
          network of experienced, qualified professionals and a local market
          presence, we are uniquely positioned to help you determine your needs
          for executive recruitment and identify the right professionals to meet
          those needs. On top of that, we work closely with our in-house
          research team to help you make strong, informed decisions.
        </p>
        <p className="mt-5 text-center">
          We understand the job market in India and the requirements for success
          within this ecosystem. And that is why we have had multiple offices in
          India. Once we engage with a company, we don’t just work on finding an
          immediate solution. We also focus on building a long-term relationship
          that extends far beyond the first job placement.
        </p>
      </Container>

      <Container className="py-5">
        <Row className="g-4">
          {services.map((service, index) => (
            <Col xs={12} md={6} lg={6} key={index}>
              <div
                className="p-4 shadow-sm h-100 d-flex  gap-3"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-6">
                  {service.mainicon}
                  </div>
                  <div className="col-lg-6">
                    <div>
                      <h5
                        className="fw-bold mb-2 mt-3 text-start text-sm-center text-md-center text-lg-start"
                        style={{ color: "var(--primary-color)" }}
                      >
                        {service.title}
                      </h5>
                      <p className="text-muted mb-3 text-start text-sm-center text-md-center text-lg-start">
                        {service.description}
                      </p>
                      <div className="d-flex align-items-center justify-content-between mt-auto">
                        <div
                          className="p-3 rounded-4"
                          style={{ border: "1px solid var(--primary-color)" }}
                        >
                          <img src={ArrowTop} alt="ArrowTop" />
                        </div>
                        <img src={service.icon} alt="service.icon" />
                        {/* <span className="text-primary">{service.icon}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      {/* <Container>
        <h1
          className="Heading43 mt-5"
          style={{ textAlign: "start", margin: "0rem 0rem 4rem 0rem" }}
        >
          Why choose Udaya Solutions permanent staffing solutions?
        </h1>
        <p>
          Udaya Solutions works with the best clients. We have highly skilled
          professionals who work hard looking after the demands of the
          companies. It is our unique knowledge and extraordinary approach that
          takes care of each employer and the employee through Udaya Slutions
          General Staffing. For Employers, recruiting new professionals is very
          easy with Udaya Solutions services. Of course, we are quick in our
          Staffing Solutions. That is why we train job enthusiasts with
          Temporary Staffing Solutions, to show true potential every day at
          their duties.
        </p>
      </Container>
      <h1
        className="Heading43 mt-5"
        style={{ textAlign: "center", margin: "0rem 0rem 4rem 0rem" }}
      >
        Executive Hiring
      </h1>
      <Container className="ourservicesasection">
        <div className="ourserviceitems">
          <img src={Briefcase} alt="Briefcase" />
          <div className="ourserviceitemstext">Executive Search</div>
          <p>
            We specialize in finding top executives to lead your business to
            success.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={Icomoon} alt="Icomoon" />
          <div className="ourserviceitemstext">Leadership Recruitment</div>
          <p>
            We focus on hiring senior leadership talent that aligns with your
            organization's vision and goals.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={OcticonGraph} alt="OcticonGraph" />
          <div className="ourserviceitemstext">C-Level Hiring</div>
          <p>
            Finding and recruiting C-level executives with the experience and
            leadership qualities your company needs.
          </p>
        </div>
        <div className="ourserviceitems">
          <img src={Exchange} alt="Exchange" />
          <div className="ourserviceitemstext">Executive Coaching</div>
          <p>
            We offer executive coaching services to ensure your new leaders
            succeed in their roles and grow with your company.
          </p>
        </div>
      </Container> */}

      <Footer />
    </>
  );
};

export default Services4;
